module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapitre Cinq")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em",
      "text-transform": "uppercase"
    }
  }, [_vm._v("LA")]), _vm._v(" beauté de la plage à cet endroit coupa le souffle d’Adam. Les vagues rugissaient en frappant les falaises de corail et la lune presque pleine illuminait l’écume dans leur sillage. Des petits crabes glissaient autour et les embruns des vagues en dessous captaient la lumière et miroitaient en dansant dans les airs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527278206"
    }
  }, [_vm._v("— C’est… c’est…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mon endroit préféré sur terre, dit Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam frissonna au son de sa voix, juste derrière lui. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("J’ai trop bu")]), _vm._v(", se dit-il, sachant que c’était un mensonge. La vérité, c’était que cela faisait trop longtemps qu’il ne s’était pas permis de regarder un autre homme et encore moins un aussi attirant et fascinant que Jonah James.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La brise fraîche rafraichissait ses joues et soulevait les poils légèrement moites sur son cou. Il soupira et ferma un court instant les yeux permettant à la beauté d’envahir ses sens et de chasser toute pensée de son esprit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merci, dit-il après un long moment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Les mots semblaient être une reconnaissance dérisoire pour le cadeau que Jonah lui avait fait. Il n’aurait jamais trouvé cet endroit tout seul.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ce dernier fit un geste vers le sol et ils s’assirent. Adam serra ses genoux contre lui et posa son menton sur eux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est paisible, dit Jonah, ses mots manquant de se perdre alors qu’une autre vague déferlait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Au ton de Jonah, Adam se demanda si celui-ci avait sa propre agitation interne à calmer. Quelle étrange soirée ! Tout d’abord, à cause de cette manière qu’avait Jonah de percevoir… non, de… "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("comprendre")]), _vm._v(", tant de choses quant à ce qu’Adam ressentait. À cause de la manière dont Adam s’était lui-même ouvert à un homme qu’il venait de rencontrer et du fait que cela lui ait semblé si naturel. Et parce que Jonah avait découvert la vérité, mais ne l’avait pas forcé à en parler plus qu’il ne le souhaitait. Une soirée pleine de surprises.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Et le paradis")]), _vm._v(". Il faillit rire à cette pensée, puis il décida qu’il ne discuterait pas cela. L’Éden était un fantasme, après tout.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, ça l’est.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il fut surpris par l’émotion brute de sa voix.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il se pencha vers l’autre homme sans réfléchir. Jonah hésita et Adam se demanda s’il avait mal lu les indices. Il se retourna pour regarder l’océan, mais la main de Jonah sur son menton l’arrêta. Ce dernier guida doucement le visage d’Adam vers le sien et ils s’embrassèrent. Doucement, au début, les lèvres se frôlant à peine, puis les dents cédèrent le passage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Josh avait le goût tentant et dangereux de l’océan. Adam flotta sur la surface lisse du baiser avec la certitude qu’en un instant, il pourrait se noyer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Un fantasme. Le paradis")]), _vm._v(". Comme dans les romans d’amour que sa mère lisait. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Mieux que ça")]), _vm._v(". Il laissa ses pensées suivre chaque vague, chaque souffle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu te sens mieux ? demanda finalement Jonah à la fin du baiser.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui. Il existe quelque chose dans l’océan qui m’aide à me détendre. Et cet endroit… Je ne connais pas un endroit plus parfait, répondit-il avec un soupir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai passé presque chacune de mes journées libres à explorer le littoral lorsque je suis arrivé ici pour la première fois en provenance de Punta Cana. Parfois sur mon vélo, la plupart du temps à pied. J’ai trouvé cet endroit quelques mois plus tard et je n’ai jamais eu envie d’explorer à nouveau.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu cherchais ça.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Peut-être.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("L’expression de Jonah changea presque imperceptiblement et Adam crut y voir une lueur de tristesse ou de regret.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment as-tu atterri en République Dominicaine ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Un heureux accident, répondit Jonah avec un haussement d’épaules. Mais je n’ai jamais regretté d’être venu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Quelle étrange réponse. Il y avait clairement plus dans l’histoire, mais Adam n’insista pas sur la question. Il espérait en apprendre davantage sur Jonah, mais il comprenait que tout ce qui se passait entre eux ne serait qu’une aventure de vacances.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Où se trouve ton endroit zen ? demanda Jonah après un autre long silence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne suis pas sûr d’en avoir encore trouvé un, bien que ma famille ait une maison à Napa où je séjourne souvent. Elle est proche d’un grand vignoble. La vue du patio arrière est étonnante à l’automne, lorsque les arbres commencent à changer de couleur. Je continue à menacer de déplacer l’entreprise là-bas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu n’y vis pas en permanence ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai un appartement à San Francisco. C’est plus près des bureaux de Prestco dans la Silicon Valley, expliqua Adam. J’aime cette ville, ne te méprends pas, ajouta-t-il en souriant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mais ce n’est pas pareil. La Silicon Valley n’est pas exactement l’endroit où je voudrais passer beaucoup de temps.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— As-tu travaillé là-bas ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’en suis pas sûr, dit Jonah, paraissant momentanément perdu. Oui. Je suppose qu’on peut dire ça.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Une autre réponse étrange")]), _vm._v(". Mais Adam n’avait pas l’impression que Jonah cherchait à tout garder pour lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Alors, parle-moi de ta famille, enchaîna rapidement Jonah comme s’il avait réalisé l’étrangeté de la réponse qu’il venait de donner et qu’il essayait de changer de sujet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je… bien sûr. Mais je n’ai pas grand-chose à dire. Je crois que je t’ai parlé de ma sœur, Karen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527300492"
    }
  }, [_vm._v("— L’avocate en brevets, indiqua Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui. J’ai un frère, Roger. Il est professeur de mathématiques dans un lycée à San José.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ta mère est toujours en vie ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Définitivement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jonah rit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est aussi une battante. Elle a beaucoup souffert de la mort de mon père. Plus durement que nous trois. Elle vit en Floride. Elle est partie là-bas six mois après le décès de mon père et elle revient rarement en Californie")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Au moins, ils avaient réussi à garder la grande maison familiale à Napa, même si Karen et son mari étaient les seuls occupants réguliers pour l’instant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ta sœur t’a encouragé à venir ici ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam le fixa.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment as-tu…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est logique. Je me suis dit que tu n’étais pas vraiment du genre à prendre des vacances à en juger par les difficultés que tu as eues à te détendre. Surtout avec une tempête en préparation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Elle avait raison, admit Adam. J’en ai besoin. Une semaine ne fera pas une si grande différence.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu te sens un peu moins nerveux, maintenant ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je… oui, dit-il après avoir réfléchi à la question. Je suppose que cet endroit va y contribuer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le fait de parler à quelqu’un qui n’était pas un membre de la famille ne faisait pas de mal non plus. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Il est magnifique en plus")]), _vm._v(". Non qu’il puisse oublier ce fait particulier. Il l’imaginait déjà torse nu. Non, plus que torse nu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam sentait que Jonah n’était pas disposé à parler de son histoire, il laissa donc ses propres questions sans réponse et en posa une qui, il l’espérait, serait moins personnelle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Alors, à quoi ressemble la vie au paradis ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— À rien de très excitant, répondit Jonah, le clair de lune illuminant son visage souriant. Se lever, déjeuner, travailler, dîner, dormir et recommencer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu ne rends pas cela très attrayant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Si tu regardes les choses ainsi, ça ne l’est pas, affirma Jonah, dont le visage affichait une expression lointaine comme s’il voyait quelque chose au-delà du ciel et de la lune. Mais c’est pour ça que c’est parfait. Pas de stress. Personne ne te demande quelque chose que tu ne veux pas faire. Tu fais ton boulot et quand tu sors, c’est fini.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suppose que oui, si c’est ce qui te rend heureux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam était presque sûr qu’il ne serait pas heureux ainsi, malgré le stress de sa propre vie. C’était peut-être plus simple d’être seul, mais il adorait passer du temps avec Karen et Ken à la maison. Et peut-être qu’avec un futur petit-fils ou une future petite-fille, sa mère pourrait être prête à venir plus souvent. L’idée d’être un oncle le fit sourire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527309726"
    }
  }, [_vm._v("— Nous devrions y retourner, dit Jonah en se levant et en tendant la main à Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Après qu’il l’eut aidé à se lever, ils se tinrent debout sous le clair de lune, assez près pour se toucher. Mais Jonah ne se pencha pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527323206"
    }
  }, [_vm._v("— Merci d’avoir partagé cet endroit avec moi, dit Adam, en se demandant s’il n’avait pas mis l’autre homme mal à l’aise en lui parlant d’être seul et de souhaiter qu’ils puissent rester plus longtemps.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Si seulement, il avait le courage d’embrasser Jonah à nouveau.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd17a53a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0009.vue
// module id = 81
// module chunks = 0